import type { FragmentType } from 'src/gql';
import { graphql, unmaskFragment } from 'src/gql';
import { liabilitySubtitle, liabilityTitle, renderIconForLiability } from 'src/utils/liability';

import NetWorthItemDescriptionRow from './views/net-worth-item-description-row';

export const NetWorthLiabilityDescriptionRowFragment = graphql(/* GraphQL */ `
  fragment NetWorthLiabilityDescriptionRow on Liability {
    ...RenderIconForLiability
    id
    name
    type
  }
`);

export default function NetWorthLiabilityDescriptionRow({
  liabilityFrag,
}: {
  readonly liabilityFrag: FragmentType<typeof NetWorthLiabilityDescriptionRowFragment>;
}) {
  const liability = unmaskFragment(NetWorthLiabilityDescriptionRowFragment, liabilityFrag);
  return (
    <NetWorthItemDescriptionRow
      icon={renderIconForLiability(liability)}
      subtitle={liabilitySubtitle(liability.type)}
      title={liabilityTitle({ liabilityName: liability.name })}
    />
  );
}
